import { render } from "./page-md-editor.vue?vue&type=template&id=679b2fd6&scoped=true"
import script from "./page-md-editor.vue?vue&type=script&lang=js"
export * from "./page-md-editor.vue?vue&type=script&lang=js"

import "./page-md-editor.vue?vue&type=style&index=0&id=679b2fd6&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679b2fd6"]])

export default __exports__